import { useCallback, useEffect, useRef } from "react";
import Router from "next/router";
import { useRouterEvents } from "hooks/useRouterEvents";
import { useSignupDispatch } from "components/Signup/store/hooks";
import {
  hydrateStep,
  updateActiveStep,
} from "components/Signup/store/slices/navigation";
import { StepName } from "components/Signup/steps/types";

const getRoute = () => {
  if (Array.isArray(Router.query.step)) {
    return Router.query.step[0];
  }
  return Router.query.step ?? "";
};

export function useRouteListener() {
  const dispatch = useSignupDispatch();
  const firstRun = useRef(false);

  const routeChange = useCallback(() => {
    const stepNameFromRoute = getRoute();

    if (stepNameFromRoute && firstRun.current) {
      dispatch(updateActiveStep(stepNameFromRoute as StepName));
    }

    if (!firstRun.current) {
      firstRun.current = true;
    }
  }, [dispatch]);

  useRouterEvents("routeChangeComplete", routeChange);

  // Run once on boot to sync the state
  useEffect(() => {
    dispatch(hydrateStep(getRoute() as StepName));
    routeChange();
  }, [dispatch, routeChange]);
}
